import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-register-error',
  templateUrl: './register-error.page.html',
  styleUrls: ['./register-error.page.scss'],
})
export class RegisterErrorPage implements OnInit {

  errorMsg = "";
  emailOrPhone = "";
  constructor(private storageService: StorageService) { }

  async ngOnInit() {
    this.errorMsg = await this.storageService.get('error-message');
    this.emailOrPhone = this.errorMsg.includes("@") ? 'email' : 'teléfono';
  }

}
